/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<g clip-path="url(#svgicon-external-a)" clip-rule="evenodd"><path pid="0" d="M8.627.547a.455.455 0 0 1 0 .643L2.842 6.975a.455.455 0 0 1-.643-.643L7.984.547a.455.455 0 0 1 .643 0z"/><path pid="1" d="M2.686.869c0-.251.204-.455.455-.455h5.165c.25 0 .454.204.454.455v5.165a.455.455 0 0 1-.909 0v-4.71h-4.71a.455.455 0 0 1-.455-.455zM0 9.132c0-.25.204-.454.455-.454h9.09a.455.455 0 0 1 0 .909H.455A.455.455 0 0 1 0 9.132z"/></g><defs><clipPath id="svgicon-external-a"><path pid="2" _fill="#fff" d="M0 0h10v10H0z"/></clipPath></defs>'
  }
})
